<div class="portlet light">
    <storever-header-page [icon]="'fad fa-tachometer'"
                          [title]="'DASHBOARD_SALES_MAIN_TITLE'"
                          [isEdit]="false">
    </storever-header-page>
    <div class="portlet-body">
      <label class="col-md-1" translate>DASHBOARD_SALES_INPUT_YEAR_LABEL</label>
      <div class="fa-pull-left col-xs-12 col-12 col-md-3 form-group">
        <select class="form-control" [(ngModel)]="year" (change)="yearChange()">
          <option *ngFor="let yearSelect of years"  >{{yearSelect}}</option>
        </select>

    </div>
    <div class="col-md-2" style="top: 9px;" *ngIf="isInRole$('BO_BILLING_SALES_DASHBOARD_EDIT') | async">
        <span tooltip="{{'DASHBOARD_SALES_UPDATE_TARGET' | translate:locale.language}}" (click)="showModal('target')"><i class="fa-lg fas fa-bullseye-pointer"></i></span>
        <span tooltip="{{'DASHBOARD_SALES_EDIT' | translate:locale.language}}" (click)="showModal('content')"><i class="fas fa-edit"></i></span>
      <span  *ngIf="isInRole$('BO_BILLING_SALES_DASHBOARD_EXPORT') | async">
        <span tooltip="{{'DASHBOARD_SALES_EXPORT' | translate:locale.language}}" (click)="showModal('exportModal')"><i class="fa-lg fas fa-file-excel"></i></span>
      </span>
    </div>
      <div class="fa-pull-right">
        <span >{{'DASHBOARD_SALES_LAST_UPDATED' | translate:locale.language}} {{updated | date: 'dd/MM/yyyy'}}</span>
      </div>
    <table *ngIf="dataSum; else noData" class="table table-bordered table-condensed">
      <thead>
      <tr>
        <th translate>GENERIC_NAME</th>
        <th translate>DASHBOARD_SALES_TABLEHEADER_NEW_SUBSCRIPTIONS</th>
        <th translate>DASHBOARD_SALES_TABLEHEADER_LOST_SUBSCRIPTIONS</th>
        <th translate>DASHBOARD_SALES_TABLEHEADER_AVERAGE_PRICE</th>
        <th translate>DASHBOARD_SALES_TABLEHEADER_GOAL_SUSCRIPTIONS</th>
        <th translate>DASHBOARD_SALES_TABLEHEADER_HARDWARE</th>
        <th translate>DASHBOARD_SALES_TABLEHEADER_GOAL_HARDWARE</th>
        <th translate>DASHBOARD_SALES_TABLEHEADER_CONTENT</th>
        <th translate>DASHBOARD_SALES_TABLEHEADER_GOAL_CONTENT</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let item of dataSum">
        <td>{{ item.name }}</td>
        <td>{{ item.new }}</td>
        <td>{{ item.lost }}</td>
        <td>{{ item.averagePrice | number: '1.0-2':'be' }}</td>
        <td>{{ item.goalSubscriptions | number: '1.0-0':'be' }} ({{item.percentGoalSubscriptions | number: '1.0-0':'be'}} %)</td>
        <td>{{ item.hardware | number: '1.0-0':'be' }}</td>
        <td>{{ item.goalHardware | number: '1.0-0':'be' }}</td>
        <td>{{ item.content | number: '1.0-0':'be' }}</td>
        <td>{{ item.goalContent | number: '1.0-0':'be' }}</td>
      </tr>
      <tr class="total-row">
        <td>Total</td>
        <td>{{ newSum }}</td>
        <td>{{ lostSum }}</td>
        <td>{{ averagePrice | number: '1.0-2':'be' }}</td>
        <td>{{ goalSubscriptionsSum | number: '1.0-2':'be' }} ({{(newSum/goalSubscriptionsSum)*100 | number: '1.0-0':'be'}} %)</td>
        <td>{{ hardwareSum | number: '1.0-2':'be' }}</td>
        <td>{{ goalHardwareSum | number: '1.0-2':'be' }}</td>
        <td>{{ contentSum | number: '1.0-2':'be' }}</td>
        <td>{{ goalContentSum | number: '1.0-2':'be' }}</td>
      </tr>
      </tbody>
    </table>
    <ng-template #noData>
      <div class="no-data" translate>GENERIC_NO_DATA</div>
    </ng-template>
        <storever-highcharts-chart
        [Highcharts] = "highchartsRef"
        [options] = "chartOptions"
        [(update)]="updateFromInput"
        [oneToOne]="true"
        style = "width: 100%; height: 400px; display: block;">
     </storever-highcharts-chart>
    </div>

  </div>
<storever-modal-update-target #targetModal
                               [targets]="(targetItems$ | async)"
                               [year]="year"
></storever-modal-update-target>
<storever-modal-sales-dashboard-export #exportModal  [year]="year"></storever-modal-sales-dashboard-export>
<storever-modal-update-content #contentModal
                               [year]="year"
                               [contents]="(contentItems$ | async)" ></storever-modal-update-content>
